var _rect, _path, _ellipse, _path2, _ellipse2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#ACFB68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.704 363.874C193.724 363.874 213.212 350.569 227.025 329.979C240.855 309.365 249.288 281.1 249.288 250.066C249.288 219.032 240.855 190.767 227.025 170.153C213.212 149.563 193.724 136.258 171.704 136.258C149.684 136.258 130.196 149.563 116.383 170.153C102.553 190.767 94.1205 219.032 94.1205 250.066C94.1205 281.1 102.553 309.365 116.383 329.979C130.196 350.569 149.684 363.874 171.704 363.874Z",
    fill: "white",
    stroke: "#0E0E0E",
    strokeWidth: 7.48365
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.482,
    cy: 251.478,
    rx: 35.3825,
    ry: 52.9431,
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.742 363.874C349.762 363.874 369.25 350.569 383.063 329.979C396.893 309.365 405.326 281.1 405.326 250.066C405.326 219.032 396.893 190.767 383.063 170.153C369.25 149.563 349.762 136.258 327.742 136.258C305.722 136.258 286.234 149.563 272.421 170.153C258.591 190.767 250.159 219.032 250.159 250.066C250.159 281.1 258.591 309.365 272.421 329.979C286.234 350.569 305.722 363.874 327.742 363.874Z",
    fill: "white",
    stroke: "#0E0E0E",
    strokeWidth: 7.48365
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.52,
    cy: 251.463,
    rx: 35.3825,
    ry: 52.9431,
    fill: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.399 225.34C312.278 226.741 305.917 233.102 304.516 241.224C303.116 233.102 296.754 226.741 288.633 225.34C296.754 223.94 303.116 217.579 304.516 209.457C305.917 217.579 312.278 223.94 320.399 225.34Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.158 225.34C155.036 226.741 148.675 233.102 147.275 241.224C145.874 233.102 139.513 226.741 131.391 225.34C139.513 223.94 145.874 217.579 147.275 209.457C148.675 217.579 155.036 223.94 163.158 225.34Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadimage);
export default __webpack_public_path__ + "static/media/head.image.526d7a1e5a1a896985a6fcb1577a5dc1.svg";
export { ForwardRef as ReactComponent };